style= require('./time-trial-results.styl')
if match && match.season
  .wrapper.column
    .controls
      section
        a(href="/matches/" + match._id + "/lineups")
          ft-button(warning) Match Setup
        each source in matchSources
          if canScrapeLineups(source)
            ft-button(warning, (click)=this.scrapeLineups(source))
              | Scrape #{source.source}
        sporty-match-times(match=match)
        if canComputeAggregate
          ft-button(warning, (click)=this.computeAggregate())
            | Compute aggregate stats
        ft-button(success,
          (click)=this.sendFeeds(),
          disabled=match.$isSubmitting
        ) Send events
        ft-button(href=`/matches/${match._id}/feeds`)
          | Download Feed
      section
        each event in eventTypes
          .event(
            (click)=this.selectEventType(event),
            class=this.eventClass(event),
          )
            .name= this.eventName(event)
      section
        each period in match.batches
          ft-button(
            accent=period === batch,
            (click)=this.batch = period
          )= period
    .match
      sporty-status(match=match)
    .wrapper
      .wrapper.column
        label
          if hasShootingEvents
            | Misses
            each val in [5,4,3,2,1,0]
              .event(
                (click)=this.setMisses(val),
                title=val + ' misses',
                class=this.isSelected(val),
              )=val
        header
          label
            | Search
            ft-form-control(
              [(value)]= this.search,
              placeholder="Search for name or team",
            )
          label
            | Time
            ft-form-control(
              [(value)]= this.time,
              placeholder="Finishing time",
            )

        .unranked
          each lineup in unranked
            .player(
              (click)=this.addTime(lineup),
              title=lineup.player.fullName,
              class={submitting: cantSubmit || lineup.$isSubmitting},
            )
              .name= lineup.player.name
              .team= '(' + (lineup.team && lineup.team.short) + ')'
    ft-button(
      success,
      (click)=this.editMode = !this.editMode
    )= this.editMode ? 'Cancel' : 'Edit stats'
    .wrapper
      .stats
        h3= match.sport === 'horses' ? 'Horses' : 'Riders'
        if match.periods
          each batch in match.batches
            - var batched = this.batched(batch)
            if batched.length
              header
                h3= 'Race ' + batch
              sporty-stats.block(
                match=match,
                batch=batch,
                edit-mode=editMode,
                event-type=rankType,
                exclude-positions='["manager", "rider", "coach"]'
              )
          header
            h3 All Racers
        sporty-stats.block(
          match=match,
          edit-mode=editMode,
          event-type=rankType,
          exclude-positions='["manager", "rider", "coach"]'
        )
      if showManager(match)
        .stats
          h3 Managers
          sporty-stats.block(
            match=match,
            edit-mode=editMode && ['cc_ski','alpine','biathlon'].includes(match.sport),
            position='manager',
          )
    sporty-feeds(match=match)
    if this.editMode
      ft-button(success, (click)=this.saveStats())
        | Save

  .eventsgroups
    .events
      .deleteButtons
        ft-button(
          warning,
          (click)=this.destroySelectedEvents(concatEvents(nameSortedEvents))
        )
          | Delete Selected
      each eventsByName in nameSortedEvents
        .deleteButtons
          ft-button(
            danger,
            (click)=this.destroyAllEvents(eventsByName)
          )
            | Delete All
        each event in eventsByName
          .event(class={submitting: event.$isSubmitting})
            if isResult(event)
              .rank= (event.minute % 1000) + '.'
            else if event.name.indexOf('time') + 1
              .rank= timestamp(event)
            else if event.name.indexOf('shooting') + 1
              .rank= (event.minute) + ' Misses'
            if event.team
              .team(title=event.team.name) (#{event.team.short})
            if event.player
              .name(title=event.player.fullName)= event.player.name
            .type= event.name
            ft-icon.delete(
              name="ui--cross",
              (click)=this.destroy(event)
            )
            ft-toggle.eventSelected(
              type="checkbox",
              name=event.name,
              checked=event.selected,
              (toggle)=this.toggleSelected(event)
            )

